function ErrorPage() {
	return <h1 style={{ textAlign: 'center' }}>404</h1>
}

export { ErrorPage }
